<template>
    <g>
        <marker
            :id="markerId"
            viewBox="0 0 10 10"
            refX="9"
            refY="5"
            markerUnits="strokeWidth"
            markerWidth="10"
            markerHeight="10"
            orient="auto-start-reverse"
        >
            <path d="M 0 0 L 10 5 L 0 10 z" :fill="color" />
        </marker>

        <line :x1="x" :x2="x2" :y1="y" :y2="y2" :stroke="color" :marker-end="`url(#${markerId})`" :marker-start="`url(#${markerId})`"></line>
        <g v-if="isVerticalPlan">
            <line :x1="indicatorX" :x2="from.x" :y1="y" :y2="from.y" :stroke="color"></line>
            <line :x1="indicatorX" :x2="from.x" :y1="y2" :y2="to.y" :stroke="color"></line>
            <foreignObject
                width="105"
                height="23"
                :transform="`translate(${indicatorX - 18 * axisCoef},${(y + y2) / 2 + 25 * axisCoef})rotate(${-90 * axisCoef})`"
            >
                <div xmlns="http://www.w3.org/1999/xhtml">
                    <NumberInput v-if="!disabled" :value="value" @input="e => $emit('input', e)" />
                    <span v-else>{{ value.toFixed(2) }}</span> &nbsp;mm
                </div>
            </foreignObject>
        </g>
        <g v-else>
            <line :x1="from.x" :x2="x" :y1="indicatorY" :y2="from.y" :stroke="color"></line>
            <line :x1="to.x" :x2="x2" :y1="indicatorY" :y2="to.y" :stroke="color"></line>
            <foreignObject width="105" height="23" :transform="`translate(${(x + x2) / 2 - 25}, ${indicatorY - 18 * axisCoef})`">
                <div xmlns="http://www.w3.org/1999/xhtml">
                    <NumberInput v-if="!disabled" :value="value" @input="e => $emit('input', e)" />
                    <span v-else>{{ value.toFixed(2) }}</span> &nbsp;mm
                </div>
            </foreignObject>
        </g>
    </g>
</template>

<script>
import { createUUID } from "@/utils/string";
import NumberInput from "@/plano/components/number-input";

export default {
    props: {
        from: { required: true, type: Object },
        spacing: { type: Number, required: true },
        spacingDirection: { type: String, required: true },
        to: { required: true, type: Object },
        value: { required: true, type: Number },
        color: { type: String, default: "red" },
        disabled: { type: Boolean, default: false }
    },
    components: { NumberInput },
    data: () => ({ markerId: undefined }),
    created() {
        this.markerId = createUUID();
    },
    computed: {
        axisCoef() {
            if (this.spacingDirection === "bottom") return 0;
            if (this.spacingDirection === "right") return -1;
            return 1;
        },
        isVerticalPlan() {
            return this.spacingDirection === "left" || this.spacingDirection === "right";
        },
        indicatorX() {
            switch (this.spacingDirection) {
                case "left":
                    return this.x - 10;
                case "right":
                    return this.x + 10;
                default:
                    return this.x;
            }
        },
        indicatorY() {
            switch (this.spacingDirection) {
                case "top":
                    return this.y - 10;
                case "bottom":
                    return this.y + 10;
                default:
                    return this.y;
            }
        },
        x() {
            const x = this.from.x;
            switch (this.spacingDirection) {
                case "left":
                    return x - this.spacing;
                case "right":
                    return x + this.spacing;
                default:
                    return x;
            }
        },
        y() {
            const y = this.from.y;
            switch (this.spacingDirection) {
                case "top":
                    return y - this.spacing;
                case "bottom":
                    return y + this.spacing;
                default:
                    return y;
            }
        },
        x2() {
            const x = this.to.x;
            switch (this.spacingDirection) {
                case "left":
                    return x - this.spacing;
                case "right":
                    return x + this.spacing;
                default:
                    return x;
            }
        },
        y2() {
            const y = this.to.y;
            switch (this.spacingDirection) {
                case "top":
                    return y - this.spacing;
                case "bottom":
                    return y + this.spacing;
                default:
                    return y;
            }
        }
    }
};
</script>
<style lang="scss" scoped>
div {
    display: flex;
}
input {
    width: 65px;

    &[disabled] {
        cursor: not-allowed;
    }
}
</style>



// WEBPACK FOOTER //
// size-arrow.vue?129f720a